import { useTranslation } from "react-i18next";

export const useClientTypeTabsTranslate = () => {
  const { t } = useTranslation();

  return {
    yourClients: t("clientsPage_tradingReport_tab_yourClients", {
      defaultValue: "Your clients",
    }),
    sharedWithYou: t("clientsPage_tradingReport_tab_sharedWithYou", {
      defaultValue: "Shared with you",
    }),
  };
};
